import { BaseColumnSchemaPart } from "@for-it/domain-lib";
import { EntitySchema } from "typeorm";
export const IdentityType = {
    DNI: "DNI",
    PASSPORT: "PASSPORT",
};
export const MaritalStatus = {
    MARRIED: "MARRIED",
    SINGLE: "SINGLE",
    DIVORCED: "DIVORCED",
    WIDOWED: "WIDOWED",
};
export const ApplicantEntity = new EntitySchema({
    name: "applicants",
    columns: {
        ...BaseColumnSchemaPart,
        identityType: {
            type: "varchar",
            nullable: false,
            enum: IdentityType,
        },
        identityNumber: {
            type: "varchar",
            nullable: true,
            unique: true,
        },
        maritalStatus: {
            type: "varchar",
            nullable: true,
            enum: MaritalStatus,
        },
        linkedin: {
            type: "varchar",
            nullable: true,
        },
        gender: {
            type: "varchar",
            nullable: true,
        },
        nationality: {
            type: "varchar",
            nullable: true,
        },
        hasCertifications: {
            type: "boolean",
            nullable: true,
        },
        certifications: {
            type: "simple-array",
            nullable: true,
        },
        ong: {
            type: "varchar",
            nullable: true,
        },
        firstJob: {
            type: "boolean",
            nullable: true,
        },
        address: {
            type: "varchar",
            nullable: true,
        },
        gitHub: {
            type: "varchar",
            nullable: true,
        },
        userId: {
            type: "uuid",
            unique: true,
            nullable: false,
        },
        provinceId: {
            type: "uuid",
            nullable: true,
        },
        localityId: {
            type: "uuid",
            nullable: true,
        },
    },
    relations: {
        user: {
            type: "one-to-one",
            target: "users",
            joinColumn: {
                name: "userId",
            },
            cascade: false,
        },
    },
});
export function applicantFilterSecureProperties(applicant) {
    return {
        id: applicant.id,
        identityType: applicant.identityType,
        identityNumber: applicant.identityNumber,
        maritalStatus: applicant.maritalStatus,
        linkedin: applicant.linkedin,
        gitHub: applicant.gitHub,
        gender: applicant.gender,
        nationality: applicant.nationality,
        hasCertifications: applicant.hasCertifications,
        certifications: applicant.certifications,
        ong: applicant.ong,
        firstJob: applicant.firstJob,
        address: applicant.address,
        userId: applicant.userId,
        provinceId: applicant.provinceId,
        localityId: applicant.localityId,
        createdAt: applicant.createdAt,
        updatedAt: applicant.updatedAt,
        deletedAt: applicant.deletedAt,
    };
}
